// extracted by mini-css-extract-plugin
module.exports = {"progressDots":"ProgressDots_progressDots__2gfEg","dot":"ProgressDots_dot__j7u7m","dot--active":"ProgressDots_dot--active__QroP_"};